import {Dialog, FlatButton} from 'material-ui';
import autoBind from 'react-autobind';
import {List} from 'immutable';
import {ValidationError} from './';
import React, {Component, PropTypes} from 'react';

export default class ValidationSummary extends Component {
  constructor(props) {
    super(props);

    autoBind(this);

    this.state = {closed: false};
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.errors === nextProps.errors) return;

    this.setState({closed: false});
  }

  handleClose() {
    this.setState({closed: true});
  }

  render() {
    const actions = [
      <FlatButton
        label="Dismiss"
        primary
        onTouchTap={this.handleClose} />,
    ];

    const {errors} = this.props;

    if (this.state.closed || !errors.size) return null;

    return (
      <Dialog
        className="validation-summary">
        onRequestClose={this.handleClose}
        actions={actions}
      >
        <h4>Please correct the following errors:</h4>
        <ul>
          {errors.map(error => <ValidationError key={error} error={error} />)}
        </ul>
      </Dialog>
    );
  }
}

ValidationSummary.propTypes = {
  errors: PropTypes.instanceOf(List).isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/ValidationSummary.js